import {RideShareScreen} from "@src/features/ride-share/ui/screens/ride-share-screen";
import * as React from "react";
import {type RouteObject} from "react-router-dom";


export function getRideShareRoutesDefinitions(): RouteObject[] {
	return [
		{
			index: true,
			element: <RideShareScreen/>,
		},
	] satisfies RouteObject[];
}
